'use client';

import cx from 'classnames';
import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { IconSearch } from '../../../../design-system/components/icons/Search';

import style from './PrimaryNavSearchIconButton.module.css';

type Props = {
    onClick: () => void;
    className?: string;
};

export const PrimaryNavSearchIconButton = forwardRef<HTMLButtonElement, Props>(
    function PrimaryNavSearchIconButton({ onClick, className }, ref) {
        const { formatMessage } = useIntl();

        return (
            <button
                ref={ref}
                type="button"
                className={cx(style.trigger, className)}
                aria-label={formatMessage({ id: 'page.home.searchPlaceholder' })}
                onClick={onClick}
            >
                <div className={style.iconWrapper}>
                    <IconSearch className={style.icon} />
                </div>
            </button>
        );
    },
);
